<script setup lang="ts">
import { computed } from 'vue';
import { ArrowRight, ArrowLeft, ArrowUpRight, Check, ChevronDown, ChevronRight, Fingerprint, Globe, Heart,
  House, Info, KeyRound, Laptop, LayoutGrid, LoaderCircle, LogOut, Mail, Menu, MessageCircle, Monitor,
  MoreHorizontal, Orbit, Plus, Search, Settings2, ShieldCheck, ShieldX, Sparkles, Trash2, Users, X,
  Eye, EyeOff, Copy, CheckCircle2, CircleAlert, Bell, Clock3, Pencil, Smartphone, Activity, ChartNoAxesCombined } from 'lucide-vue-next';
const props = withDefaults(defineProps<{ name: string; size?: number }>(), { size: 20 });
const icons: Record<string, any> = { ArrowRight, ArrowLeft, ArrowUpRight, Check, ChevronDown, ChevronRight, Fingerprint, Globe, Heart,
  House, Info, KeyRound, Laptop, LayoutGrid, LoaderCircle, LogOut, Mail, Menu, MessageCircle, Monitor,
  MoreHorizontal, Orbit, Plus, Search, Settings2, ShieldCheck, ShieldX, Sparkles, Trash2, Users, X,
  Eye, EyeOff, Copy, CheckCircle2, CircleAlert, Bell, Clock3, Pencil, Smartphone, Activity, ChartNoAxesCombined };
const component = computed(() => icons[props.name] || Info);
</script>
<template><component :is="component" :size="size" :stroke-width="1.7" /></template>
